<template>
    <div class="plus-minus-number">
        <div class="plus-minus-button minus" @click="minus()">
            -
        </div>
        <div class="field-container">
            <input type="number" v-model="newValue" disabled />
        </div>
        <div class="plus-minus-button plus" @click="plus()">
            +
        </div>
    </div>
</template>

<script>
export default {
    name: "PlusMinusField",
    props: {
        value: {
            default: 0,
            type: Number
        },
        banknote: {
            default: 1,
            type: Number
        },
        min: {
            default: 0,
            type: Number
        },
        max: {
            default: undefined,
            type: Number
        }
    },
    data () {
        return {
            newValue: 0
        }
    },
    methods: {
        plus() {
            if (this.max === undefined || (this.newValue < this.max)) {
                this.newValue = this.newValue + 1;
                this.$emit('input', this.newValue, this.banknote);
            }
        },
        minus() {
            if ((this.newValue) > this.min) {
                this.newValue = this.newValue - 1;
                this.$emit('input', this.newValue, this.banknote);
            }
        }
    },
    watch: {
        value: {
            handler(newVal) {
                this.newValue = newVal;
            }
        }
    },
    created() {
        this.newValue = this.value;
    }
}
</script>
<style lang="scss" scoped>
.plus-minus-number {
    border:1px solid silver;
    border-radius:5px;
    background-color: #FFF;
    margin:0 5px 0 5px;
    display:inline-block;
    user-select: none;
}
.plus-minus-number div {
    display:inline-block;
}
.plus-minus-number .field-container input {
    width:50px;
    text-align:center;
    font-size:15px;
    padding:3px;
    border:none;
}
.plus-minus-number .plus-minus-button {
    padding:3px 10px 3px 10px;
    cursor:pointer;
    border-radius:5px;
}
.plus-minus-number .plus-minus-button:hover {
    background-color:#DDD;
}
.plus-minus-number .plus-minus-button:active {
    background-color:#c5c5c5;
}
</style>
